import React, { useState, useRef, useEffect } from "react";
import { LuSearch } from "react-icons/lu";
import { IoCalendarOutline } from "react-icons/io5";
import trip from "./assets/images/trip.webp";
import intercity from "./assets/images/intercity.webp";
import ad1 from "./assets/images/ad1.webp";
import ad2 from "./assets/images/ad2.webp";
import ad3 from "./assets/images/ad3.webp";
import ad4 from "./assets/images/ad4.webp";
import { IoCalendarSharp } from "react-icons/io5";
import { IoCarSportSharp } from "react-icons/io5";
import { CgSmileMouthOpen } from "react-icons/cg";
import { FaRoute } from "react-icons/fa6";

import { useNavigate } from "react-router-dom";
import PlanYourTripModal from "./PlanYourTripModal";
import ReserveTripModal from "./ReserveTripModal";
import GoToTop from "../GoToTop";
import { Helmet } from "react-helmet";

function Hero() {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showReserveModal, setShowReserveModal] = useState(false);

  const [counts, setCounts] = useState({
    customers: 0,
    local: 0,
    outstation: 0,
  });

  useEffect(() => {
    animateCount("customers", 12500);
    animateCount("local", 8200);
    animateCount("outstation", 3450);
  }, []);

  function animateCount(key, target) {
    let start = 0;
    const speed = target / 80;

    const counter = setInterval(() => {
      start += speed;
      if (start >= target) {
        start = target;
        clearInterval(counter);
      }
      setCounts((prev) => ({ ...prev, [key]: Math.floor(start) }));
    }, 20);
  }

  const handleTripSearch = (data) => {
    navigate(
      `/ride/${data.pickup.toLowerCase().replace(/\s+/g, "-")}-to-${data.drop
        .toLowerCase()
        .replace(/\s+/g, "-")}`,
      {
        state: {
          pickup: data.pickup,
          drop: data.drop,
          isScheduled: data.isScheduled,
          pickupDate: data.pickupDate,
          pickupTime: data.pickupTime,
        },
      },
    );
  };

  const handleReserveTripSearch = (data) => {
    navigate("/choose-reserve-car", {
      state: {
        pickup: data.pickup,
        drop: data.drop,
        pickupDate: data.pickupDate,
        pickupTime: data.pickupTime,
        dropDate: data.dropDate,
      },
    });
  };

  const images = [ad3];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    }, 7000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <GoToTop />
      <Helmet>
        <title>DibruGo | Taxi Service in Dibrugarh</title>
        <meta
          name="description"
          content="Book reliable taxi service in Dibrugarh with DibruGo. Affordable airport transfers, local rides, and outstation trips with professional drivers."
        />
        <meta
          property="og:title"
          content="DibruGo – Best Taxi Service in Dibrugarh | Airport & Local Cabs"
        />
        <meta
          property="og:description"
          content="Book reliable taxi service in Dibrugarh with DibruGo. Affordable airport transfers, local rides, and outstation trips with professional drivers."
        />
      </Helmet>
      <div className="container section-hero web-main mb-3">
        <div className="row">
          {/* Left: visual + stats */}
          <div className="col-md-7 mb-2">
            <div className="uber-hero-visual">
              <img
                src={images[currentIndex]}
                className="img-fluid mb-1"
                alt="Dibrugarh Taxi Service"
                style={{ borderRadius: "13px" }}
              />
            </div>

            <div className="stats-section mt-4 desktopview">
              <div className="stats-card gradient-1 mb-2">
                <div className="stats-icon icon-1">
                  <IoCarSportSharp />
                </div>
                <h2 className="text-1">8,200+</h2>
                <p className="text-1">Local Rides</p>
                <span className="stats-badge text-1">Completed</span>
              </div>

              <div className="stats-card gradient-2 mb-2">
                <div className="stats-icon icon-2">
                  <FaRoute />
                </div>
                <h2 className="text-2">3,450+</h2>
                <p className="text-2">Outstation Rides</p>
                <span className="stats-badge text-2">This Year</span>
              </div>

              <div className="stats-card gradient-3 mb-2">
                <div className="stats-icon icon-3">
                  <CgSmileMouthOpen style={{ fontSize: "26px" }} />
                </div>
                <h2 className="text-3">11,500+</h2>
                <p className="text-3">Happy Customers</p>
                <span className="stats-badge text-3">And Growing</span>
              </div>
            </div>
          </div>

          {/* Right: Uber-style booking card */}
          <div className="col-md-5">
            <div className="uber-hero-card">
              <div
                className="ride-search-bar"
                onClick={() => setShowModal(true)}
              >
                <div className="ride-left">
                  <LuSearch className="search-icon" />
                  <span>Where to?</span>
                </div>

                <div
                  className="ride-later"
                  onClick={(e) => {
                    e.stopPropagation();
                    // console.log("Later clicked");
                  }}
                >
                  <IoCalendarOutline className="icon calendar-icon" />
                  <span style={{fontSize:'13px'}}>Schedule Later</span>
                </div>
              </div>
            </div>

            <div className="ride-suggestions mt-3">
              <h6 className="suggestion-title">Quick Actions</h6>

              <div className="suggestion-grid">
                <div
                  className="suggestion-card"
                  onClick={() => setShowModal(true)}
                >
                  {/* Top Section */}
                  <div className="suggestion-top bg-a">
                    <div className="suggestion-icon icon-bg-a">
                      <IoCarSportSharp />
                    </div>

                    <img
                      src={trip}
                      alt="Pick & Drop"
                      className="suggestion-img"
                    />
                  </div>

                  {/* Bottom Section */}
                  <div className="suggestion-content">
                    <h5 className="suggestion-heading">Pick & Drop</h5>
                    <p className="suggestion-sub mb-0">
                      One-way ride within or from Dibrugarh
                    </p>

                    <div className="suggestion-arrow arrow-bg-a">→</div>
                  </div>
                </div>

                {/* Reserve */}
                <div
                  className="suggestion-card"
                  onClick={() => setShowReserveModal(true)}
                >
                  {/* Top Section */}
                  <div className="suggestion-top bg-b">
                    <div className="suggestion-icon icon-bg-b">
                      <IoCalendarSharp />
                    </div>

                    <img
                      src={intercity}
                      alt="Pick & Drop"
                      className="suggestion-img"
                    />
                  </div>

                  {/* Bottom Section */}
                  <div className="suggestion-content">
                    <h5 className="suggestion-heading">Reserve</h5>
                    <p className="suggestion-sub mb-0">
                      Keep a cab with you for multiple days
                    </p>

                    <div className="suggestion-arrow arrow-bg-b">→</div>
                  </div>
                </div>
              </div>
            </div>

            <img
              src={ad1}
              onClick={() => setShowReserveModal(true)}
              className="img-fluid mt-4 mb-2 rounded-3"
              alt="Dibrugarh Taxi Service"
            />

            
          </div>
        </div>
      </div>

      {/* Modal Component */}
      <PlanYourTripModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onSearchRide={handleTripSearch}
      />

      <ReserveTripModal
        showReserve={showReserveModal}
        onCloseReserve={() => setShowReserveModal(false)}
        onSearchReserveRide={handleReserveTripSearch}
      />
    </>
  );
}

export default Hero;
